import type { ListItemRow } from '../../db/types';

export const STATUS_LABEL: Record<ListItemRow['status'], string> = {
  pending: 'do kupienia',
  cart: 'w koszyku',
  missing: 'brak',
  partial: 'częściowo',
  substitute: 'zamiennik',
};

export type ChipTone = 'ok' | 'miss' | 'partial' | 'neutral';

export const CHIP_CLS: Record<ChipTone, string> = {
  ok: 'bg-brand-100 text-brand-800 dark:bg-brand-800/40 dark:text-brand-100',
  miss: 'bg-orange-100 text-miss-600 dark:bg-miss-600/25 dark:text-orange-200',
  partial: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200',
  neutral: 'bg-stone-200 text-stone-700 dark:bg-stone-800 dark:text-stone-200',
};

type ChipSource = Pick<ListItemRow, 'status' | 'qty' | 'partialQty' | 'substitute'>;

/** Krótki opis statusu odhaczonej pozycji: „✓”, „brak”, „1/2”, „zamiennik: …”. */
export function statusChip(i: ChipSource): { text: string; tone: ChipTone } {
  switch (i.status) {
    case 'cart':
      return { text: '✓', tone: 'ok' };
    case 'missing':
      return { text: 'brak', tone: 'miss' };
    case 'partial':
      return { text: i.partialQty !== null && i.qty !== null ? `${i.partialQty}/${i.qty}` : 'częściowo', tone: 'partial' };
    case 'substitute':
      return { text: i.substitute ? `zamiennik: ${i.substitute}` : 'zamiennik', tone: 'neutral' };
    default:
      return { text: 'do kupienia', tone: 'neutral' };
  }
}

/** Polska odmiana liczebnika: 1 pozycja, 2 pozycje, 5 pozycji. */
export function plural(n: number, one: string, few: string, many: string): string {
  if (n === 1) return one;
  const d = n % 10;
  const dd = n % 100;
  return d >= 2 && d <= 4 && (dd < 12 || dd > 14) ? few : many;
}

/** „Magda”, „Magda i Bartek”, „Magda, Bartek i Ola”. */
export function joinNames(names: string[]): string {
  if (names.length <= 1) return names[0] ?? '';
  return `${names.slice(0, -1).join(', ')} i ${names.at(-1)}`;
}

/** Godzina do opisu statusu, np. „14:05”. */
export function timeLabel(ms: number): string {
  return new Date(ms).toLocaleTimeString('pl-PL', { hour: '2-digit', minute: '2-digit' });
}
